import { Box } from "@material-ui/core";
import React, { useContext } from "react";
import FormBase from "../../../../forms/FormBase";
import Steps from "../../../../components/steps/Steps";
import RefusalPresentVaccineTerm from "../../../components/materialui/TermsDeclarations/RefusalPresentVaccineTerm";
import ImmunityDeclaration from "../../../components/materialui/TermsDeclarations/ImmunityDeclaration";
import { RefusalPresentVaccineItem } from "../../../../forms/shared/termsDeclarations/RefusalPresentVaccineForm";
import { MultiprofissionalContext } from "../../../../context/MultiprofissionalContext";
import MultiprofessionalDeclaration from "../../../components/materialui/Multiprofissional/termsDeclarations/MultiprofessionalDeclaration"
import AbsenceConflictDeclaration from "../../../components/materialui/Multiprofissional/termsDeclarations/AbsenceConflictDeclaration";


export default function TermsDeclarationsStep() {

    const { state, dispatch } = useContext(MultiprofissionalContext);

    const onInputChange = (name: string, form: FormBase, value: any) => {
        dispatch({
            type: "UPDATE_FORM",
            payload: { form, value, name },
        });
    };


    const onInputRefusalPresentVaccineItemChange = (name: string, form: FormBase, value: any, item: RefusalPresentVaccineItem) => {
        dispatch({
            type: "UPDATE_FORM_REFUSAL_PRESENT_VACCINE_ITEM",
            payload: { form, value, name, item },
        });
    };

    return (
        <div>
            <Steps.StepTitle text="Termos e Declarações" />

            <Box mt={2}>
                <AbsenceConflictDeclaration
                    TermsDeclarationsForm={state.TermsDeclarationsForm}
                    Name={state.PersonalDataForm.Name.Value}
                    Specialty={state.PersonalAddressDataForm.getSpecialty()}
                    Crm={state.PersonalDataForm.CRM.Value}
                    onInputChange={onInputChange} />

            </Box>



            <Box mt={2}>
                <RefusalPresentVaccineTerm
                    Name={state.PersonalDataForm.Name.Value}
                    onInputChange={onInputChange}
                    Checked={state.TermsDeclarationsForm.RefusalPresentVaccineTerm.Value.Checked}
                    onCheckedClick={(e: boolean) => { onInputChange("RefusalPresentVaccineTerm", state.TermsDeclarationsForm, e) }}
                    onInputRefusalPresentVaccineItemChange={onInputRefusalPresentVaccineItemChange}
                    RefusalPresentVaccineForm={state.RefusalPresentVaccineForm}
                />

            </Box>

            <Box mt={2}>
                <ImmunityDeclaration
                    Checked={state.TermsDeclarationsForm.ImmunityDeclaration.Value.Checked}
                    onCheckedClick={(e: boolean) => { onInputChange("ImmunityDeclaration", state.TermsDeclarationsForm, e) }}
                    Name={state.PersonalDataForm.Name.Value}
                    onInputChange={onInputChange} />

            </Box>

            <Box mt={2}>
                <MultiprofessionalDeclaration
                    TermsDeclarationsForm={state.TermsDeclarationsForm}
                    onInputChange={onInputChange} />

            </Box>

        </div>
    );
}